import { Container, Grid, Tooltip, Typography } from "@mui/material";
import singleShipment from "../../assets/shipment-type/Single.png";
import masterShipment from "../../assets/shipment-type/Master.png";
import mixedShipment from "../../assets/shipment-type/Mixed.png";
import "./ShipmentType.css";

const ShipmentType = (props) => {
  const { setShipmentType, shipmentType } = props;
  const selectShipType = (type) => {
    setShipmentType(type);
  };

  return (
    <Container className="containerImage">
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <div
            className={
              "singleShipment " +
              (shipmentType === "single" ? "selectedShipType" : "")
            }
            onClick={() => selectShipType("single")}
          >
            <Tooltip
              title="The sample you are testing includes one box (on a pallet or not on a pallet) or multiples boxes not on a pallet."
              placement="top"
            >
              <div>
                <Typography variant="body1" className="ShipTypeLabel">
                  Single
                </Typography>
                <img src={singleShipment} alt="Single Shipment" />
              </div>
            </Tooltip>
          </div>
        </Grid>
        <Grid item xs={12} sm={4}>
          <div
            className={
              "masterShipment " +
              (shipmentType === "master" ? "selectedShipType" : "")
            }
            onClick={() => selectShipType("master")}
          >
            <Tooltip
              title="The sample you are testing includes a pallet (or pallets) with more than one box/container on it. Master shipment indicates there is only one part number within the boxes on a pallet."
              placement="top"
            >
              <div>
                <Typography variant="body1" className="ShipTypeLabel">
                  Master
                </Typography>
                <img src={masterShipment} alt="Master Shipment" />
              </div>
            </Tooltip>
          </div>
        </Grid>
        <Grid item xs={12} sm={4}>
          <div
            className={
              "mixedShipment " +
              (shipmentType === "mixed" ? "selectedShipType" : "")
            }
            onClick={() => selectShipType("mixed")}
          >
            <Tooltip
              title="The sample you are testing includes a pallet (or pallets) with more than one box/container on it. Mixed shipment indicates there are different part numbers within the boxes on a pallet."
              placement="top"
            >
              <div>
                <Typography variant="body1" className="ShipTypeLabel">
                  Mixed
                </Typography>
                <img src={mixedShipment} alt="Mixed Shipment" />
              </div>
            </Tooltip>
          </div>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ShipmentType;
